import { Add } from "@mui/icons-material";
import { Stack, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { MultiPictureUploadSubtypeResponse } from "../../../../types/actionModule/subtypes/multiPictureUploadSubtype";

export default function MultiPictureUploadEditorPreview(state: SubtypeState) {
    const { t } = useTranslation();

    const subtype = state.properties as Partial<MultiPictureUploadSubtypeResponse>;
    const pictureDescription = subtype.pictureDescription;
    const exampleImageUrl = subtype.exampleImageUrl;

    return <Stack direction="column">
        {pictureDescription && <Typography variant="body1">{pictureDescription}</Typography>}
        {exampleImageUrl && <img src={exampleImageUrl} style={{ width: "100%", margin: "10px" }} />}
        <Box
            sx={{
                borderColor: "grey",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "16px",
                padding: "30px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            }}
        >
            <Add /> {t("actionModules.subtypes.multiPictureUpload.previewTakePicture")}
        </Box>
    </Stack>;
}